const vehicleMarkerPopup = {
  batteryLevel: ' Battery Level', 
  estimatedRange: 'Estimated Range',
  chargingStatus: 'Charging Status',
  charging: 'Charging',
  notCharging: 'Not Charging',
  unknown: 'unknown',
};

export default vehicleMarkerPopup;